"use client";

import { serviceOfferTranslations } from "@/lib/sharedTranslations";

export default function ServiceOfferBanner({ locale = "pt" }: { locale?: "pt" | "en" }) {
  const t = serviceOfferTranslations[locale] ?? serviceOfferTranslations["pt"];

  return (
    <div className="mt-20 text-center">
      <div className="bg-[#D3DC7C] rounded-lg p-6 text-center shadow-md">
        <h2 className="text-[#1B475D] text-lg font-semibold">{t.heading}</h2>
        <p className="mb-2">{t.subtext}</p>
        <a
          href={`/${locale}/register`}
          className="inline-block bg-[#8ebd9d] hover:bg-[#77A885] text-[#1B475D] font-semibold px-4 py-2 rounded"
        >
          {t.button}
        </a>
      </div>
    </div>
  );
}
